import { render } from "./ProgramChairCourseOutcomes.vue?vue&type=template&id=4b152fed"
import script from "./ProgramChairCourseOutcomes.vue?vue&type=script&lang=js"
export * from "./ProgramChairCourseOutcomes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__